import { controls } from "../../controls";
const rprbi3 = {
  label: "ACP Disbursement",
  starting: true,
  url: "ACP Disbursement",
  pageLabel: "ACP Disbursement",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "n" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI ACP Disbursement",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    textReportProps: {
      'LBS': {
        filename: `RBI-ACP_Disbursement-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,
    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "Crop Loan Count",
        accessor: "disb_count",
      },
      {
        Header: "Crop loan Amount",
        accessor: "croploan_amount",
      },
      {
        Header: "Term loan Count",
        accessor: "term_count",
      },
      {
        Header: "Term Loan Amount",
        accessor: "farmterm_amount",
      },
      {
        Header: "Allied No.",
        accessor: "allied_count",
      },
      {
        Header: "Allied Amount",
        accessor: "farmallied_amount",
      },
      {
        Header: "Agri Infra No.",
        accessor: "x",
      },
      {
        Header: "Agri Infra Amount",
        accessor: "x2",
      },

      {
        Header: "Ancilllary Count",
        accessor: "x3",
      },
      {
        Header: "Ancilllary Amount",
        accessor: "x4",
      },

      {
        Header: "Micro Ent No.",
        accessor: "x5",
      },
      {
        Header: "Micro Ent Amount",
        accessor: "x6",
      },

      {
        Header: "Small Ent No.",
        accessor: "x7",
      },
      {
        Header: "Small Ent Amount",
        accessor: "x8",
      },
      {
        Header: "Medium Ent No.",
        accessor: "mediument_count",
      },
      {
        Header: "Medium Ent Amount",
        accessor: "mediument_amount",
      },
      {
        Header: "Khadi and Village",
        accessor: "villageind_count",
      },
      {
        Header: "Medium Ent Amount",
        accessor: "villageind_amount",
      },
      {
        Header: "Other MSMEs No.",
        accessor: "othermsme_count",
      },
      {
        Header: "Other MSMEs Amount",
        accessor: "11m",
      },
      {
        Header: "Export Cr. No.",
        accessor: "Expo_crno",
      },
      {
        Header: "Export Cr. Amount",
        accessor: "Expo_cramt",
      },
      {
        Header: "Education PS No.",
        accessor: "edu_psno",
      },
      {
        Header: "Education PS Amount",
        accessor: "edu_psamt",
      },
      {
        Header: "Housing PS No.",
        accessor: "housingps_count",
      },
      {
        Header: "Housing PS Amount",
        accessor: "housingps_amount",
      },
      {
        Header: "Social Infra No.",
        accessor: "social_infrano",
      },
      {
        Header: "Social Infra Amount",
        accessor: "social_infraamt",
      },
      {
        Header: "Renewable Energy No.",
        accessor: "renergy_no",
      },
      {
        Header: "Renewable Energy Amount",
        accessor: "renergy_amt",
      },
      {
        Header: "Other Proirity No.",
        accessor: "shg_count",
      },
      {
        Header: "Other Proirity Amount",
        accessor: "shg_amount",
      },
      {
        Header: "Loans weaker sec. PS No.",
        accessor: "weaker_psno",
      },
      {
        Header: "Loans weaker sec. PS Amount",
        accessor: "weaker_psamt",
      },
      {
        Header: "Agricultre NPS No.",
        accessor: "agri_npsno",
      },
      {
        Header: "Agricultre NPS Amount",
        accessor: "agri_npsamt",
      },
      {
        Header: "Education NPS No.",
        accessor: "edu_npsno",
      },
      {
        Header: "Education NPS Amount",
        accessor: "edu_npsamt",
      },
      {
        Header: "Housing NPS No.",
        accessor: "21m_count",
      },
      {
        Header: "Housing NPS Amount",
        accessor: "21m",
      },
      {
        Header: "Personal Loan NPS No.",
        accessor: "personalnps_count",
      },
      {
        Header: "Personal NPS Amount",
        accessor: "personalnps_amount",
      },
      {
        Header: "Other NPS No.",
        accessor: "othernps_count",
      },
      {
        Header: "Other NPS Amount",
        accessor: "othernps_amount",
      },
    ]
  }
};
export default rprbi3;